import * as THREE from 'three'
import React, { useRef, useEffect, useMemo } from 'react'
import { extend, useThree, useFrame } from 'react-three-fiber'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader'
import { LookUpShader } from '../shaders/LookUpShader'
import { Controls, useControl } from 'react-three-gui';

extend({ EffectComposer, ShaderPass, RenderPass, UnrealBloomPass })

export default function Effects() {
  const color_1 = useControl('Point 1', {
    type: 'color',
    group: 'Gradient',
    value: '#151524',
  });

  const color_2 = useControl('Point 2', {
    type: 'color',
    group: 'Gradient',
    value: '#912E2E',
  });

  const color_3 = useControl('Point 3', {
    type: 'color',
    group: 'Gradient',
    value: '#F2A922',
  });

  const color_4 = useControl('Point 4', {
    type: 'color',
    group: 'Gradient',
    value: '#ACFF71',
  });

  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <shaderPass
        attachArray="passes"
        args={[LookUpShader]}
        material-uniforms-color1-value={color_1}
        material-uniforms-color2-value={color_2}
        material-uniforms-color3-value={color_3}
        material-uniforms-color4-value={color_4}
      />
      <unrealBloomPass attachArray="passes" args={[aspect, 1.5, 1.5, 0.5]} />
      <shaderPass
        attachArray="passes"
        args={[FXAAShader]}
        material-uniforms-resolution-value={[1 / size.width, 1 / size.height]}
        renderToScreen
      />
    </effectComposer>
  )
}
